var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnowy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}.cls-2{stroke-width:7px;}.cls-3{stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snowy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snowy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.36,108.68H181.9c3.87,0,18.26-1.84,15.77-19.09-3.87-26.84-30.44-17.71-30.44-17.71s6-14.85-8-26.29c-18.26-14.94-32.65-2.49-32.65-2.49s-4.15-19.65-32.93-17.71C62.86,27.46,63.74,50.85,63.74,50.85a20.34,20.34,0,0,0-24.63-1.66C24.6,58.19,28.6,71,28.6,71S6.73,68.85,2.87,86C-1.29,104.41,11.17,108.68,18.36,108.68Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.81,
    y1: 127.79,
    x2: 78.81,
    y2: 173.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.4,
    y1: 150.69,
    x2: 54.22,
    y2: 150.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 93.84,
    y1: 165.72,
    x2: 63.78,
    y2: 135.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 93.84,
    y1: 135.66,
    x2: 63.78,
    y2: 165.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.85,
    y1: 114.23,
    x2: 129.85,
    y2: 149.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 147.33,
    y1: 131.88,
    x2: 112.38,
    y2: 131.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140.53,
    y1: 142.56,
    x2: 119.17,
    y2: 121.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140.53,
    y1: 121.2,
    x2: 119.17,
    y2: 142.56
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowy);
export default __webpack_public_path__ + "static/media/snowy.1e2d58f11772d037ab5226e8f539d1ea.svg";
export { ForwardRef as ReactComponent };